import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import GlassCard from "./GlassCard";

export default function Pin(props) {
  const isMobile = useMediaQuery("(max-width: 700px)");

  return (
    <GlassCard
      sx={{
        mb: 1,
        padding: "16px 20px",
        "&:hover": {
          border: "1px solid rgba(133,224,255,0.85)",
          boxShadow: "0 8px 36px rgba(0,0.85)",
        },
        transition: "border 0.25s, box-shadow 0.25s",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box>
          <Typography
            component="div"
            variant={isMobile ? "subtitle1" : "h6"}
            sx={{
              fontFamily: "Roboto",
              fontWeight: isMobile ? 600 : 500,
              color: "#fff",
            }}
          >
            {props.title}
          </Typography>
        </Box>

        <Box>
          <Typography
            component="div"
            variant="body2"
            sx={{
              fontFamily: "RobotoLight",
              fontWeight: 300,
              color: "rgba(133,224,255,0.85)",
              fontSize: "0.78rem",
              mt: 0.25,
            }}
          >
            {props.desc1}
            {props.desc2 ? (
              <Box
                component="span"
                sx={{ color: "rgba(255,255,255,0.85)", mx: 0.5 }}
              >
                {" | "}
              </Box>
            ) : null}
            {props.desc2 ? (
              <Box component="span" sx={{ color: "rgba(255,255,255,0.85)" }}>
                {props.desc2}
              </Box>
            ) : null}
          </Typography>
        </Box>

        {props.startDate ? (
          <Box>
            <Typography
              component="div"
              variant="caption"
              sx={{
                fontFamily: "RobotoLight",
                fontWeight: 300,
                color: "rgba(255,255,255,0.85)",
                fontStyle: "italic",
                mt: 0.5,
                display: "block",
              }}
            >
              📅 {props.startDate}
            </Typography>
          </Box>
        ) : null}

        {props.subheading ? (
          <Box>
            <Typography
              component="div"
              variant="caption"
              sx={{
                fontFamily: "RobotoLight",
                fontWeight: 300,
                color: "#FF83A8",
                fontStyle: "italic",
                mt: 0.5,
                display: "block",
              }}
            >
              🏆 {props.subheading}
            </Typography>
          </Box>
        ) : null}

        {props.desc3 ? (
          <Box sx={{ mt: 1 }}>
            <Typography
              component="div"
              variant="body2"
              sx={{
                fontFamily: "RobotoLight",
                fontWeight: 300,
                color: "rgba(255,255,255,0.85)",
                lineHeight: 1.7,
                whiteSpace: "pre-line",
              }}
            >
              {props.desc3}
            </Typography>
          </Box>
        ) : null}
      </Box>
    </GlassCard>
  );
}
